"use client";

import { useEffect, useState } from "react";
import { STEP_MAX, STEP_MIN, STEP_VW_FACTOR } from "./tempo-drill-helpers";

/**
 * Inter-chord pixel offset, scaled with viewport width so chords don't
 * spread out unnecessarily on narrow screens.
 *
 * Clamped to [STEP_MIN, STEP_MAX]; the upper bound matches the historical
 * fixed value, so wide-screen layout is unchanged.
 */
export function useResponsiveStep(): number {
  const [step, setStep] = useState(STEP_MAX);

  useEffect(() => {
    const compute = () => {
      const target = window.innerWidth * STEP_VW_FACTOR;
      setStep(Math.max(STEP_MIN, Math.min(STEP_MAX, target)));
    };

    compute();
    window.addEventListener("resize", compute);

    return () => window.removeEventListener("resize", compute);
  }, []);

  return step;
}
